<template>
  <BaseSelect
    v-model="modelValue"
    v-bind="$attrs"
    :options="options"
    size="sm"
    label="Year of Account"
    :rules="$props.required ? 'required' : ''"
  >
    <template v-slot:label>
      Year of Account <span v-if="$props.required" class="text-danger">*</span>
    </template>

    <template v-slot:first>
      <option :value="undefined" disabled>Select year of account</option>
    </template>
  </BaseSelect>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import { BaseSelect } from '@components/base'
import { KEEP_AS_IS_OPTION } from '@constants'

export default defineComponent({
  name: 'BDXEditFormYearOfAccount',
  components: {
    BaseSelect
  },
  props: {
    value: [String, Number],
    required: Boolean,
    useKeepAsIsOption: Boolean,
  },
  emits: ['input'],
  setup(props, { emit }) {
    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    const options = computed(() => {
      const startYear = 2006
      const endYear = new Date().getFullYear()
      let options = Array.from(
        { length: endYear - startYear + 1 },
        (_, i) => startYear + i
      ).reverse()
      if (props.useKeepAsIsOption) {
        options = [KEEP_AS_IS_OPTION, ...options];
      }
      return options;
    })

    return {
      modelValue,

      options
    }
  }
})
</script>
